var KissTariffsPassOption = /*@__PURE__*/ (function () {
    function KissTariffsPassOption(passId, passIcon, callback) {
        this.liSelectedClass = "selected";
        this.svgSelectedClass = "i-white";
        this.ID_PLACEHOLDER = "PASS_ID";
        this.ICON_PLACEHOLDER = "PASS_ICON";
        this.template = "<a class=\"mod-ep-kiss-tariffs__passes-tab ep-shop-tab-selection__tab\" " +
            "                id=\"pass-" + this.ID_PLACEHOLDER + "-tab\"" +
            "                href=\"#\"" +
            "                 role=\"tab\"" +
            "                 aria-controls=\"pass-content-" + this.ID_PLACEHOLDER + "\"" +
            "                 aria-selected=\"\"" +
            "                 data-tariff-id=\"" + this.ID_PLACEHOLDER + "\"" +
            "                 onclick=\"event.preventDefault()\">" +
            "                  <svg class=\"i-sml\">" +
            "                     <use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"/simplicity/svgdefs.svg#i-" + this.ICON_PLACEHOLDER + "-sml\">" +
            "                     </use>" +
            "                  </svg>" +
            "                 </a>";
        this.container = document.createElement("li");
        this.passId = passId;
        this.passIcon = passIcon;
        this.selected = false;
        this.onClickFn = callback;
        this.setup();
        this.container.innerHTML = this.template;
    }
    KissTariffsPassOption.prototype.setup = function () {
        var _this = this;
        while (this.template.indexOf(this.ID_PLACEHOLDER) > -1) {
            this.template = this.template.replace(this.ID_PLACEHOLDER, this.passId + "");
        }
        while (this.template.indexOf(this.ICON_PLACEHOLDER) > -1) {
            this.template = this.template.replace(this.ICON_PLACEHOLDER, this.passIcon + "");
        }
        this.container.addEventListener('click', function () {
            if (!_this.disabled) {
                _this.onClickFn(_this.passId);
            }
        });
    };
    KissTariffsPassOption.prototype.setSelected = function (selected) {
        this.selected = selected;
        if (this.selected) {
            this.container.classList.add(this.liSelectedClass);
            this.container.querySelector("svg").classList.add(this.svgSelectedClass);
        }
        else {
            this.container.classList.remove(this.liSelectedClass);
            this.container.querySelector("svg").classList.remove(this.svgSelectedClass);
        }
    };
    KissTariffsPassOption.prototype.setDisabled = function (disabled) {
        this.disabled = disabled;
        if (disabled) {
            this.container.remove();
        }
    };
    KissTariffsPassOption.prototype.render = function () {
        return this.container;
    };
    return KissTariffsPassOption;
}());
export { KissTariffsPassOption };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/shop-builder/widgets/kiss-tariffs/kiss-tariffs-pass-option.ts
// module id = null
// module chunks = 